<template>
  <DateToHuman :date="this.cellProps"></DateToHuman>
</template>

<script>
import DateToHuman from './DateToHuman.vue';
export default {
  name: "DateCell",
  components: {
    DateToHuman,
  },
  props: {
    cellProps: {
      type: String,
    },
    row: {
      type: Object,
    }
  },
  methods: {
    getSortableProperties(row, key) {
      return row[key];
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>